import type { ReactNode } from 'react';

import type { CardMenu } from '../shared/PostMenu';
import { PostFeed, PostFeedSkeleton } from './PostFeed';
import { PostList } from './PostList';
import type { ViewKey } from './PublicationsToolbar';
import type { PostEntry } from './readings';

/** The two presentations of one set of posts. */
export function PublicationsView(props: {
  view: ViewKey;
  entries: PostEntry[];
  loading?: boolean;
  hrefFor?: (entry: PostEntry) => string;
  menu?: CardMenu;
}): ReactNode {
  if (props.view === 'list') {
    return <PostList entries={props.entries} loading={props.loading} hrefFor={props.hrefFor} />;
  }
  return props.loading === true ? (
    <PostFeedSkeleton />
  ) : (
    <PostFeed entries={props.entries} hrefFor={props.hrefFor} menu={props.menu} />
  );
}
